import { useEffect, useState } from "react";
import { renderMermaidSvg } from "../utils/mermaid";
import { openDiagramLightbox } from "../utils/diagramLightbox";

/**
 * Renderiza um diagrama Mermaid na tela. O pacote `mermaid` é pesado, então é
 * carregado sob demanda (lazy import) só quando aparece um diagrama.
 *
 * Durante o streaming o código chega incompleto e a renderização falha — nesse
 * caso mostramos o código cru como fallback e tentamos de novo quando o texto
 * muda. Quando o bloco fica válido, o SVG substitui o fallback.
 */
export function Mermaid({ chart }: { chart: string }) {
  const [svg, setSvg] = useState<string>("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const code = chart.trim();
    if (!code) {
      setSvg("");
      setFailed(false);
      return;
    }
    void renderMermaidSvg(code).then((out) => {
      if (cancelled) return;
      if (out) {
        setSvg(out);
        setFailed(false);
      } else {
        setFailed(true);
        setSvg("");
      }
    });
    return () => {
      cancelled = true;
    };
  }, [chart]);

  if (svg && !failed) {
    return (
      <div
        className="mermaid-diagram"
        // SVG vem do próprio mermaid (securityLevel strict); seguro renderizar.
        dangerouslySetInnerHTML={{ __html: svg }}
        onClick={(e) => {
          const svgEl = e.currentTarget.querySelector("svg");
          if (svgEl) openDiagramLightbox(svgEl.outerHTML);
        }}
        role="button"
        tabIndex={0}
        aria-label="Ampliar diagrama"
        title="Clique para ampliar (scroll: zoom, arrastar: mover)"
      />
    );
  }

  // fallback: código cru (streaming em andamento ou diagrama inválido)
  return (
    <pre className="mermaid-fallback">
      <code>{chart}</code>
    </pre>
  );
}
